import { createContext, useContext, useMemo } from 'react';

const TopicCardContext = createContext();

const TopicCardProvider = ({
  canRemoveDescriptionPlaceholder,
  children,
  topic,
  href,
  forceDefaultLink,
  displayRequestModal,
  setDisplayRequestModal,
  updateTopicApproval,
  target,
}) => {
  const value = useMemo(
    () => ({
      canRemoveDescriptionPlaceholder,
      displayRequestModal,
      forceDefaultLink,
      href,
      setDisplayRequestModal,
      updateTopicApproval,
      target,
      topic,
    }),
    [
      canRemoveDescriptionPlaceholder,
      displayRequestModal,
      forceDefaultLink,
      href,
      setDisplayRequestModal,
      updateTopicApproval,
      target,
      topic,
    ],
  );

  return (
    <TopicCardContext.Provider value={value}>
      {children}
    </TopicCardContext.Provider>
  );
};

export const useTopicCardContext = () => {
  const context = useContext(TopicCardContext);

  if (!context) {
    throw new Error(
      'useTopicCardContext must be used within a TopicCardProvider',
    );
  }

  return context;
};

export default TopicCardProvider;
